import { getField, updateField } from 'vuex-map-fields';
import moment from 'moment';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';

const state = {
    id: 0,
    bancoCuentaId: 0,
    bancoCuenta: null,
    bancoCuentaNombre: null,
    bancoCuentaMonedaId: 0,
    bancoCuentaMoneda: null,
    fechaEmision: moment(new Date()).format('YYYY-MM-DD'),
    fechaPago: moment(new Date()).format('YYYY-MM-DD'),
    numero: 0,
    importe: 0,
    rowVersion: null,
    
    chequePropioDatos: [],
};

const mutations = {
    updateField,

    'INICIALIZAR_CHEQUE_PROPIO'(state) {
        state.id = 0;
        state.bancoCuentaId = 0;
        state.bancoCuenta = null;
        state.bancoCuentaNombre = null;
        state.bancoCuentaMonedaId = 0;
        state.bancoCuentaMoneda = null;
        state.fechaEmision = moment(new Date()).format('YYYY-MM-DD');
        state.fechaPago = moment(new Date()).format('YYYY-MM-DD');
        state.numero = '';
        state.importe = 0;
        state.rowVersion = null;
    },
    'SET_BANCO_CUENTA'(state, bancoCuenta) {
        state.bancoCuenta = bancoCuenta;

        if (bancoCuenta) {
            state.bancoCuentaId = bancoCuenta.id? bancoCuenta.id : 0;
            state.bancoCuentaNombre = bancoCuenta.nombre? bancoCuenta.nombre.trim() : null;
            state.bancoCuentaMonedaId = bancoCuenta.monedaId? bancoCuenta.monedaId : 0;
            state.bancoCuentaMoneda = bancoCuenta.moneda? bancoCuenta.moneda.trim() : null;
        } else {
            state.bancoCuentaId = 0;
            state.bancoCuentaNombre = null;
            state.bancoCuentaMonedaId = 0;
            state.bancoCuentaMoneda = null;
        }
    },

    'INICIALIZAR_CHEQUE_PROPIO_DATOS' (state) {
        state.chequePropioDatos = [];
    },
    'SET_CHEQUE_PROPIO_DATOS' (state, params) {
        state.chequePropioDatos = params.chequePropioDatos;
    }
};

const getters = {
    getField,

    chequePropio (state) {
        let chequePropio = {
            bancoCuentaId: parseInt(state.bancoCuentaId),
            monedaId: parseInt(state.bancoCuentaMonedaId),
            moneda: state.bancoCuentaMoneda,
            fechaEmision: moment(state.fechaEmision).format('YYYY-MM-DD'),
            fechaPago: moment(state.fechaPago).format('YYYY-MM-DD'),
            numero: state.numero,
            importe: parseFloat(state.importe),
        }
        return chequePropio;
    }
};

const actions = {
    inicializar ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_CHEQUE_PROPIO');
            resolve();
        })
    },
    setBancoCuenta: ({commit}, bancoCuenta) => {
        commit('SET_BANCO_CUENTA', bancoCuenta);
    },

    getChequePropioDatos ( { commit }, chequePropioId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_CHEQUE_PROPIO_DATOS');

            if (chequePropioId != 0) {
                apiAxios.get('bancosmovimientos/' + chequePropioId ) 
                .then(res => {
                    let chequePropioDatos = [
                        { 'nombre': 'bancoCuenta', 'campo': 'Cuenta', 'valor': res.data.bancoCuenta, 'formato': '' },
                        { 'nombre': 'fechaEmision', 'campo': 'Fecha Emisión', 'valor': res.data.fechaEmision, 'formato': 'fecha' },
                        { 'nombre': 'fechaPago', 'campo': 'Fecha Pago', 'valor': res.data.fechaPago, 'formato': 'fecha' },
                        { 'nombre': 'fechaCreditoDebito', 'campo': 'Fecha Débito', 'valor': res.data.fechaCreditoDebito, 'formato': 'fecha' },
                        { 'nombre': 'numero', 'campo': 'Número', 'valor': res.data.loteNumero, 'formato': '' },
                        { 'nombre': 'importe', 'campo': 'Importe', 'valor': res.data.importe, 'formato': 'moneda' },
                    ];
                    
                    let params = {
                        chequePropioDatos 
                    }
                    commit('SET_CHEQUE_PROPIO_DATOS', params);

                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
        })
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}